module.exports = __webpack_public_path__ + "d83ce38d4d018dc0b6727c3f7f15e60c.pdf";